import { FRESH_FIND_FRIDAYS_PARAM } from '../freshFind/freshFindFridaysFlag';
import { GIFT_GUIDE_HUB_PARAM } from '../hub/giftGuideHubFlag';
import {
  GIFT_GUIDE_HUB_MEMORY_KEY,
  V1_PREVIEW_MEMORY_KEY,
  previewParamValue,
  writePreviewMemory,
} from './previewMemory';
import { V1_PREVIEW_PARAM } from './v1PreviewFlag';

/**
 * Call ONCE at boot (index.js), before React mounts: remember or forget the
 * tester previews named on the landing URL. The one place preview memory is
 * written — see `previewMemory.ts` for why boot rather than the readers.
 *
 * Leaves the URL alone (unlike `initV4PreviewFlag`): the existing param
 * carriers keep working, and a tester can still see which link they opened.
 * A URL with neither an explicit `=1` nor `=0` changes nothing.
 */
export function initPreviewMemory(search: string): void {
  const v1 = previewParamValue(search, V1_PREVIEW_PARAM);
  if (v1 !== null) writePreviewMemory(V1_PREVIEW_MEMORY_KEY, v1);

  // `?freshFindFridays=` is the hub door's alias (THE-879: the two ship
  // together), so `=1` remembers the whole hub — wider than the alias's old
  // card-only reach, deliberately — and `=0` forgets it, symmetrically. An
  // explicit `?giftGuideHub=` on the same URL wins.
  const hub =
    previewParamValue(search, GIFT_GUIDE_HUB_PARAM) ??
    previewParamValue(search, FRESH_FIND_FRIDAYS_PARAM);
  if (hub !== null) writePreviewMemory(GIFT_GUIDE_HUB_MEMORY_KEY, hub);
}
